export const TASKS = `TASKS`;
export const EDIT_TASK = `EDIT_TASK`;
export const WORK = `WORK`;
